import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator} from '@angular/forms';
import {OrderService} from '../../../service/order-service';

@Component({
  selector: 'country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true
    }
  ]
})
export class CountrySelectComponent implements ControlValueAccessor, Validator {
  countries:any[] = [];
  destcities:any[] = [];

  selectedCountryId: any;
  selectedCityId: any;
  selectedCityName: any;

  private countryData: {countryId?: number, cityId?: number, cityName?: string};

  private storeData: {countryId: number, cityId: number, cityName: string};

  onChange: (selectedData: any) => void;
  onTouched: () => void;
  isDisabled: boolean;
  @Input() className: 'form-control form-control-lg form-control-solid';

  constructor(
    private orderService: OrderService,
  ) {
    this.selectedCountryId = null;
    this.selectedCityId = null;
    this.selectedCityName = '';
    this.getCountries();
    this.storeData = { countryId: null, cityId: null, cityName: null};
    console.log('init province control');
  }
  getCountries() {
    this.orderService.getCountries().subscribe(res => {
      if (res !== null) {
        this.countries = res;
      }
    }, error => {
      console.error("Cannot get list countries!!!");
    });
  }

  isSelectCountry(countryId: number): boolean {
    return !this.countryData ? false : (countryId === this.countryData.countryId);
  }
  isSelectCity(cityId: number): boolean {
    return !this.countryData ? false : (cityId === this.countryData.cityId);
  }

  writeValue(obj: any) {
    if (obj) {
      this.storeData = this.countryData = obj;
      this.selectedCountryId = this.countryData.countryId;
      this.selectedCityId = this.countryData.cityId;
      this.selectedCityName = this.countryData.cityName;
      if (obj && obj.countryId) {
        this.orderService.getDestCitiesByCountry(obj.countryId).subscribe(res => {
          if (res !== null) {
            this.destcities = res;
          }
        }, error => {
          console.error("Cannot get list destcities!!!");
        });
      }
    }
  }

  registerOnChange(fn: (countryData: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }
  countryChange(){
    const countryId = +this.selectedCountryId;
    this.storeData.countryId = countryId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getDestCitiesByCountry(countryId).subscribe(res => {
      if (res !== null) {
        this.destcities = res;
        if (this.destcities.length > 0){
          this.selectedCityId = this.destcities[0].id;
          this.selectedCityName = this.destcities[0].name;
          this.cityChange();
        }
        else{
          this.selectedCityId = null;
          this.selectedCityName = '';
          this.cityChange();
        }
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  cityChange() {
    const cityId = +this.selectedCityId;
    const cityName = this.selectedCityName;
    this.storeData.cityId = cityId;
    this.storeData.cityName = cityName;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);
  }
  handleOnCountryChange(e) {
    console.log(e);
    const countryId = parseInt(e.target.value);
    this.storeData.countryId = countryId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getDestCitiesByCountry(countryId).subscribe(res => {
      if (res !== null) {
        this.destcities = res;
        if (this.destcities.length > 0){
          this.handleOnCityChange({target: {value: this.destcities[0].id}});
        }
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  handleOnCityChange(e) {
    const cityId = parseInt(e.target.value);
    this.storeData.cityId = cityId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);
  }


  validate(c: FormControl) {
    return null;
  }
  isVisibleCityName(): boolean {
    return (!this.destcities || this.destcities.length == 0) && this.selectedCountryId;
  }
}
